import { IState } from '../IState';

const menuCatalogStoreSelector = (state: IState) => state.menuCatalog;
const menuCatalogItemsDataSelector = (state: IState) => menuCatalogStoreSelector(state).items.data;
const menuCatalogItemsMetaSelector = (state: IState) => menuCatalogStoreSelector(state).items.meta;

export const menuCatalogListSelector = (state: IState) => menuCatalogItemsDataSelector(state).list;
export const menuCatalogNetworkStatusSelector = (state: IState) => menuCatalogItemsMetaSelector(state).networkStatus;
